import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CityFrom } from "./components/fields/CityFrom";
import { CityTo } from "./components/fields/CityTo";
import { CityReplacer } from "./components/fields/CityReplacer";
import { autocomplite_load, geolocation_load } from "./redux/actions";
import { DepartureDate } from "./components/fields/DepartureDate";
import { CargoName } from "./components/fields/CargoName";
import { SizeType } from "./components/SizeType";
import { GetTickets } from "./components/GetTickets";
import { Tickets } from "./components/Tickets";
import { MobileApp } from "./MobileApp";

function App() {
    const dispatch = useDispatch();
    const autocomplite = useSelector((state) => state.app.autocomplite.loaded);
    const geolocation = useSelector((state) => state.app.geolocation.loaded);
    const isMobile = useSelector((state) => state.app.isMobile);
    const template = useSelector((state) => state.app.template);
    const handleWindowSizeChange = () => {
        if (window.innerWidth < 992 && !isMobile) {
            window.location.reload();
        }
        if (window.innerWidth >= 992 && isMobile) {
            window.location.reload();
        }
    };
    useEffect(() => {
        if (!autocomplite) {
            dispatch(autocomplite_load());
        } else {
            if (!geolocation) {
                dispatch(geolocation_load());
            }
        }
    }, [dispatch, autocomplite, geolocation]);
    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, [handleWindowSizeChange]);
    if (isMobile) {
        return <MobileApp />;
    }
    return (
        <React.Fragment>
            <section
                className={`front-calc container ${template}`}
                id="front-calc"
            >
                <div className="container__wrap">
                    <div className="front-calc__flex">
                        <div className="front-calc__path">
                            <div className="front-calc__from">
                                <CityFrom />
                            </div>
                            <div className="front-calc__city_replace">
                                <CityReplacer />
                            </div>
                            <div className="front-calc__to">
                                <CityTo />
                            </div>
                        </div>
                        <div className="front-calc__params">
                            <div className="front-calc__departure_date">
                                <DepartureDate />
                            </div>
                            <div className="front-calc__cargo_type">
                                <CargoName />
                            </div>
                        </div>
                    </div>
                    <SizeType />
                    <GetTickets />
                </div>
            </section>
            {/* <Tickets/> */}
        </React.Fragment>
    );
}

export default App;
